var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { AwesomeEvent, ComponentAPI } from '@philips-internal/oswald-ui-core';
import { ChangeEventListener, FocusEventListener, KeyboardEventListener } from '@philips-internal/oswald-ui-core/lib/component/types/index.js';
class PhoneNumberAPI extends ComponentAPI {
    constructor() {
        super(...arguments);
        /** @event */
        this.onChange = new ChangeEventListener();
        /** @event */
        this.onBlur = new FocusEventListener();
        /** @event */
        this.onFocus = new FocusEventListener();
        /** @event */
        this.onKeyDown = new KeyboardEventListener();
        /** @event */
        this.onKeyPress = new KeyboardEventListener();
        /** @event */
        this.onKeyUp = new KeyboardEventListener();
    }
    /**
     * Gets the value property.
     *
     * @returns the value property.
     */
    getValue() {
        return this.state.value;
    }
    /**
     * Sets the value property of the phone number.
     *
     * @param value - The new value.
     */
    setValue(value) {
        this.setState({ value });
    }
    /**
     * Gets the country property.
     *
     * @returns the country property.
     */
    getCountry() {
        return this.state.country;
    }
    /**
     * Sets the country property of the phone number.
     *
     * @param country - The new country.
     */
    setCountry(country) {
        this.setState({ country });
    }
    /**
     * Gets the read only property.
     *
     * @returns a boolean indicating if the phone number is read only.
     */
    isReadOnly() {
        return this.state.readOnly;
    }
    /**
     * Sets the read only property of the phone number.
     *
     * @param readOnly - If the phone number is read only.
     */
    setReadOnly(readOnly) {
        this.setState({ readOnly });
    }
    /**
     * Gets the valid property.
     *
     * @returns a boolean indicating if the phone number is valid.
     */
    isValid() {
        return this.state.valid;
    }
    /**
     * Sets the valid property of the phone number.
     *
     * @param valid - If the phone number is valid.
     */
    setValid(valid) {
        this.setState({ valid });
    }
    /**
     * Gets the enabled property.
     *
     * @returns a boolean indicating if the phone number is enabled.
     */
    isEnabled() {
        return this.state.enabled;
    }
    /**
     * Sets the enabled property of the phone number.
     *
     * @param enabled - If the phone number is enabled.
     */
    setEnabled(enabled) {
        this.setState({ enabled });
    }
    /**
     * Checks if the field value is being struckthrough.
     *
     * @returns a boolean indicating if the field value is being struckthrough.
     */
    isStrikethrough() {
        return Boolean(this.state.strikethrough);
    }
    /**
     * Sets if the field value should be struckthrough.
     *
     * @param strikethrough - If the field value should be struckthrough.
     */
    setStrikethrough(strikethrough) {
        this.setState({ strikethrough });
    }
    /**
     * Gets the configured sensitiveness for the field.
     *
     * @returns the configured sensitiveness for the field.
     */
    getSensitiveData() {
        return this.state.sensitiveData;
    }
    /**
     * Sets if the data of the field should be hidden when in read only mode.
     *
     * @param sensitiveData - How sensitive the data is.
     */
    setSensitiveData(sensitiveData) {
        this.setState({ sensitiveData });
    }
}
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], PhoneNumberAPI.prototype, "onChange", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], PhoneNumberAPI.prototype, "onBlur", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], PhoneNumberAPI.prototype, "onFocus", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], PhoneNumberAPI.prototype, "onKeyDown", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], PhoneNumberAPI.prototype, "onKeyPress", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], PhoneNumberAPI.prototype, "onKeyUp", void 0);
export { PhoneNumberAPI, };
//# sourceMappingURL=phone-number-api.js.map